<script setup>
const props = defineProps({
  selectedDonor: {
    type: Object,
    default: null,
  },
  results: {
    type: Array,
    default: []
  }
});
const sortingModes = {
  alphabetical: 'alphabetical',
  rank: 'rank'
}
const sortingMode = ref(sortingModes.rank)

const sortedResults = computed(()=>
  props.results.filter((a)=> a.label )
  .sort((a, b)=>{
    if(sortingMode.value === sortingModes.alphabetical){
      return a.label.localeCompare(b.label)
    }
    return parseFloat(a.Total) === parseFloat(b.Total) ? 0 : 
    (parseFloat(a.Total) > parseFloat(b.Total) ? -1 : 1)
  })

)
// watch(()=> props.results, () => {
//   sortedResults.value = props.results
// })
// const sortByAlphabetical = () => {
//   sortedResults.value = props.results.sort((a, b)=>{
//     return a.label.localeCompare(b.label)
//   })
  
// }
// const sortByRank =() => {
//   sortedResults.value = props.results.sort((a, b)=>{
//     return parseFloat(a.Total) === parseFloat(b.Total) ? 0 : 
//     (parseFloat(a.Total) > parseFloat(b.Total) ? -1 : 1)
//   })  
// }
const emit  = defineEmits(["close"]);
const closeDonor = () => {
  emit('close')
}
</script>
<template>
  <div
    v-if="selectedDonor"
    id="side-pannel"
    class="w-60 bg-white mt-8 lg:mt-0  px-5 py-7 h-fit rounded-lg shadow-xl relative"
  >
    <button
      class="close-donor absolute right-4 top-4 text-Categories-0"
      @click="closeDonor"
    >
    ✕</button>
    <div class="text-Categories-0 leading-7">
      <h3 class="font-semibold">Selected donor:</h3>
      {{ selectedDonor._id }}
    </div>
    <div class="divider mt-5 h-[1px] w-full bg-Primary-400" />
    <div class="text-Primary-600 mt-7">
      <h3 class="font-semibold">Related recipients:</h3>
      <div class="flex justify-between mt-4">
        <button
          @click="sortingMode = sortingModes.alphabetical"
          class="text-[11px] py-1.5 px-[10px] rounded-2.5 bg-Primary-50"
          :class="[sortingMode === sortingModes.alphabetical ? 'font-extrabold' : '' ]"
        >
          Sort alphabetical
        </button>
        <button
          @click="sortingMode = sortingModes.rank"
          class="text-[11px] py-1.5 px-[10px] rounded-2.5 bg-Primary-50"
          :class="[sortingMode === sortingModes.rank ? 'font-extrabold' : '' ]"
          >
          Sort by rank
        </button>
      </div>
      <div class="mt-2.5 overflow-y-auto overflow-x-hidden max-h-[290px] pr-2" id="side-panel-container">
        <div
          v-for="(result, index) in sortedResults"
          :key="index"
          class="flex items-center justify-between leading-7 border-b border-Neutral-100"
        >
          <h4>{{  result.label  }}</h4>
          <span>{{  $formater.salaryFormater(result.Total) }}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<style>
#side-panel-container {
  scrollbar-width: thin;
  scrollbar-color: #7882cf #F3F4FB;
}

#side-panel-container::-webkit-scrollbar {
  width: 8px;
}

#side-panel-container::-webkit-scrollbar-thumb {
  background: #7882cf;
  border-radius: 12px;
}

#side-panel-container::-moz-scrollbar-thumb {
  background: #7882cf;
  border-radius: 12px;
}

#side-panel-container::-webkit-scrollbar-track {
  background-color: #F3F4FB;
  border: 0px solid #ccc;
  border-radius: 12px;
}

#side-panel-container::-moz-scrollbar-track {
  background-color: #F3F4FB;
  border: 0px solid #ccc;
  border-radius: 12px;
}

#side-panel-container::-webkit-scrollbar-button {
  background-color: #7882cf;
  border-radius: 12px;
}

#side-panel-container::-moz-scrollbar-button {
  background-color: #7882cf;
  border-radius: 12px;
}
</style>